import React from 'react'
import { get } from 'lodash'
import { ReactTable, searchVehicle } from '../../feature-react-table'
import { useSearchVehiclesWithDealsDetailLazyQuery } from '../generated/graphql'

const {
    accessors: { account, buyerAgent, conversion, makeModelYear, saleAmount, status, statusNoAmount, stockNumber },
    Cells: { Account, BuyerAgent, MakeModelYear },
} = searchVehicle

const columns = [
    {
        Header: 'Vehicle',
        accessor: makeModelYear,
        Cell: MakeModelYear,
        width: 24,
    },
    {
        Header: 'Buyer',
        accessor: buyerAgent,
        Cell: BuyerAgent,
        width: 25,
    },
    {
        Header: 'Amount',
        accessor: saleAmount,
        width: 10,
    },
    {
        Header: 'Seller',
        accessor: account,
        Cell: Account,
        width: 25,
    },
    {
        Header: 'Floor',
        accessor: conversion,
        width: 8,
    },
    {
        Header: 'Status',
        accessor: statusNoAmount,
        width: 8,
    },
]

const mobileColumns = [
    {
        Header: 'Vehicle',
        accessor: makeModelYear,
        Cell: MakeModelYear,
    },
    {
        Header: 'Stock #',
        accessor: stockNumber,
    },
    {
        Header: 'Status',
        accessor: status,
    },
]

interface Props {
    searchString: string
    title?: string
}

export const SearchVehiclesWithDealsDetailComponent = ({ searchString, title }: Props): React.ReactElement => {
    return (
        <ReactTable
            shareMetaData={{ shareSubject: 'Vehicles' }}
            columns={columns}
            mobileColumns={mobileColumns}
            queryOptions={{ variables: { searchString } }}
            lazyQueryHook={useSearchVehiclesWithDealsDetailLazyQuery}
            countPath="auction.search.vehicleCount"
            listPath="auction.search.vehicleResult"
            title={({ res }): string => title || get(res, 'auction.search.searchStringDisplay', 'Search Results')}
        />
    )
}

export const searchVehiclesWithDealsColumns = columns
export const searchVehiclesWithDealsMobileColumns = mobileColumns
